<button
  nz-button
  nz-tooltip
  nz-popconfirm
  [nzPopconfirmOverlayClassName]="className()"
  [nzOkText]="'global.yes' | translate"
  [nzCancelText]="'global.no' | translate"
  [nzType]="type()"
  [nzDanger]="danger()"
  [nzShape]="shape()"
  [nzTooltipTitle]="tooltip()"
  [nzPopconfirmTitle]="confirmText()"
  [nzPopconfirmPlacement]="popconfirmPlacement()"
  [nzOkDanger]="danger()"
  [nzSize]="size()"
  [nzIcon]="iconTpl"
  [nzLoading]="loading()"
  [disabled]="disabled()"
  (nzOnConfirm)="onConfirm()"
  (click)="checkIfClickIsTrusted($event)"
>
  @if (icon()) {
    <span nz-icon [nzType]="icon()"></span>
  }

  @if (text()) {
    <span>{{ text() }}</span>
  }
</button>

<ng-template #iconTpl>
  <span
    nz-icon
    nzType="info-circle"
    nzTheme="twotone"
    style="margin-right: 5px"
    [nzTwotoneColor]="iconColor()"
  ></span>
</ng-template>
